import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { PlatformShortcutService } from '../../services/platform-shortcut.service';

@Component({
  selector: 'app-search-shortcut-hint',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'search-shortcut-hint-host',
    '[class.search-shortcut-hint--overlay]': 'overlay()'
  },
  template: `
    <span class="search-shortcut-hint">
      @if (lead()) {
      <span class="search-shortcut-hint__lead">{{ lead() }}</span>
      }
      <span class="search-shortcut-hint__keys" aria-hidden="true">
        <kbd class="search-shortcut-kbd">{{ shortcuts.searchLauncherModifierLabel() }}</kbd>
        <kbd class="search-shortcut-kbd search-shortcut-kbd--glyph">+</kbd>
        <kbd class="search-shortcut-kbd">Espacio</kbd>
      </span>
      @if (meta()) {
      <span class="search-shortcut-hint__meta">{{ meta() }}</span>
      }
    </span>
  `
})
export class SearchShortcutHintComponent {
  readonly shortcuts = inject(PlatformShortcutService);
  readonly lead = input('Buscar en Pento…');
  readonly meta = input('· mín. 3 caracteres');
  readonly overlay = input(false);
}
